var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content bg"},[_c('dv-full-screen-container',[_c('Moduletitle'),_c('ModuleMain')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }